module.exports = __webpack_public_path__ + "img/thank.d8600873.jpg";